import React from 'react';
import classNames from 'classnames/bind';

import styles from './Switch.css';

const cx = classNames.bind(styles);

const Switch = props => {
  const { input, onClick, disabled, checked } = props;
  const labelClassName = getLabelClassNames(props);
  return (
    <div className={styles['switch-container']}>
      <input
        {...input}
        checked={(input.value && !disabled) || checked}
        disabled={disabled}
        className={styles['switch-checkbox']}
        id={input.name}
        type="checkbox"
      />
      <label onClick={onClick} className={labelClassName} htmlFor={input.name}>
        <span className={styles[`switch-button`]} />
      </label>
    </div>
  );
};

const getLabelClassNames = ({ input, disabled, checked }) => {
  return cx({
    'switch-label': true,
    'backgoround-on': (input.value && !disabled) || checked,
  });
};

Switch.defaultProps = {
  checked: false,
};

export default Switch;
